import ErrorBoundary from '@/components/ErrorBoundary';
import { StandaloneButtonProps } from '@/components/element/Button';
import { LabradorComponent, StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { mergeOptions } from '@/utils/mergeProps';
import withDebugMetadata from '@/utils/withDebugMetadata';
import BannerImage from 'base/public/image/banner-image.svg';
import { standaloneComponent } from 'modules/dynamic-components';
import { ReactNode } from 'react';
import { Banner } from './Banner';

export interface StandaloneBannerProps extends StandaloneComponentProps<typeof Banner> {
  content?: {
    headline?: ReactNode;
    description?: ReactNode;
    button?: ReactNode;
    image?: ReactNode;
  };
  link?: StandaloneButtonProps['link'];
}

const defaultContent: StandaloneBannerProps['content'] = {
  headline: 'Korsord, sudoku och andra roliga spel att lösa!',
  description:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi.',
  button: 'Klicka här för att spela',
  image: <BannerImage />,
};

export const StandaloneBanner: StandaloneComponent<StandaloneBannerProps> = ({
  content = defaultContent,
  link = { href: '/korsord' },
  options,
  ...props
}) => {
  const { $headline, $description, $button, $image, ...$base } = options || {};
  const { headline, description, button, image } = content ?? {};

  return (
    <ErrorBoundary>
      <Banner {...$base} {...props}>
        <Banner.Headline {...$headline}>{headline}</Banner.Headline>
        <Banner.Description {...$description}>{description}</Banner.Description>
        <Banner.Button link={link} options={mergeOptions({ size: 'large' }, $button)} content={button} />
        <Banner.Image {...$image}>{image}</Banner.Image>
      </Banner>
    </ErrorBoundary>
  );
};

export const standalone = StandaloneBanner;

const DynamicStandaloneBanner = standaloneComponent<StandaloneBannerProps>('ContentBanner');
const LabradorBanner: LabradorComponent = ({ type, meta, data, descendants }) => {
  return <DynamicStandaloneBanner {...withDebugMetadata({ type, meta })} />;
};

export default LabradorBanner;
